import { render, staticRenderFns } from "./TextInformationBox.vue?vue&type=template&id=41715eaa&scoped=true"
import script from "./TextInformationBox.vue?vue&type=script&lang=ts"
export * from "./TextInformationBox.vue?vue&type=script&lang=ts"
import style0 from "./TextInformationBox.vue?vue&type=style&index=0&id=41715eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41715eaa",
  null
  
)

export default component.exports